export default __webpack_public_path__ + "static/media/Astronaut_08.f18faab0.png";